import styled, { css } from 'styled-components'

export const StyledChartContainer = styled.div`
    position: relative;
`

export const StyledChartWrapper = styled.div`
    width: 100%;
    height: 60vh;
    min-height: 300px;
`

export const StyledChart = styled.canvas``

export const StyledChartLegendWrapper = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin: 10px 0;
`

export const StyledChartLegend = styled.div`
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;
`

export const StyledChartLegendColor = styled.span`
    width: 12px; 
    height: 12px; 
    background-color: ${({ legendColor }) => legendColor};
    margin-right: 5px;
    ${({ legendType }) =>
        legendType &&
        css`
            border-radius: ${legendType === 'circle' ? '50%' : '0%'};
    `};
`

export const StyledChartLegendName = styled.span`
    white-space: nowrap;
    font-size: 12px;
    font-weight: ${({ theme }) => theme.fontWeight.bold};
`

export const StyledChartTable = styled.div`
    opacity: 1;
    position: absolute;
    top: ${({ top }) => top};
    left: ${({ left }) => left};
    padding: 10px;
    pointer-events: none;
    background: rgba(255,255,255, 0.5);
    color: #797979;
    border-radius: 6px;
    box-shadow: 5px 5px 15px -1px rgba(0,0,0,0.35);
`

export const StyledChartTableHeader = styled.div`
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 10px;
`

export const StyledChartTableBody = styled.div`
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 12px;
    font-weight: normal;
`

export const StyledChartTableBodyItem = styled.div`
    margin-bottom: 5px;
`